import { createStore } from "vuex";
import auth from "../ui/Auth/store";

const store = createStore({
    modules: {
        auth,
    },
});
export default store;
